export var slice = Array.prototype.slice;



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-shape/src/array.js
// module id = 364
// module chunks = 0